import { useEffect, useState } from "react";
import { useSDK } from "../lib/sdk-context";
import { api } from "../lib/api";

interface Candidate {
  license_number: string;
  display_name: string | null;
  legal_name: string | null;
  dba_name: string | null;
  premise_city: string | null;
  premise_street: string | null;
  license_type: string | null;
  status: string | null;
}

export default function CandidatePicker({ onPick }: { onPick: (license: string) => void }) {
  const { context } = useSDK();
  const [q, setQ] = useState("");
  const [rows, setRows] = useState<Candidate[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const t = setTimeout(async () => {
      if (q.trim().length < 2) { setRows([]); return; }
      setLoading(true);
      try {
        const r = await api.get(context, `/api/match/candidates?q=${encodeURIComponent(q)}`);
        setRows(r.rows || []);
      } finally {
        setLoading(false);
      }
    }, 250);
    return () => clearTimeout(t);
  }, [q, context]);

  return (
    <div className="border border-slate-200 rounded p-3 bg-slate-50">
      <input
        autoFocus
        className="w-full border border-slate-300 rounded px-2 py-1 bg-white"
        placeholder="Search license #, legal name, DBA…"
        value={q}
        onChange={(e) => setQ(e.target.value)}
      />
      <div className="mt-2 text-xs text-slate-500">{loading ? "Searching…" : `${rows.length} result(s)`}</div>
      <ul className="mt-2 divide-y divide-slate-200 bg-white rounded">
        {rows.map((c) => (
          <li key={c.license_number} className="px-3 py-2 flex items-center justify-between">
            <div className="text-sm">
              <div className="font-medium">{c.display_name || c.dba_name || c.legal_name || c.license_number}</div>
              <div className="text-xs text-slate-500">{c.license_number}{c.premise_city ? ` · ${c.premise_city}` : ""}{c.license_type ? ` · ${c.license_type}` : ""}</div>
            </div>
            <button className="btn-primary" onClick={() => onPick(c.license_number)}>Select</button>
          </li>
        ))}
      </ul>
    </div>
  );
}
